import { API_URL } from "../../../../../constants";
import * as httpNetworking from "../../../../../httpNetworking";

const UPGRADE_CORE_VERSION_URL = API_URL + "/saas/multi-tenancy/deployment/teleport";
const UPGRADE_CORE_VERSION_API_VERSION = 0;

type TUpgradeCoreVersionResponse = {
    available: boolean;
    reason: string;
    status: "pending" | "target-assigned" | "data-migrated" | "finished";
};

export async function upgradeCoreVersion(data: {
    targetCoreVersionX2: string;
    deploymentType: "production" | "development";
}): Promise<TUpgradeCoreVersionResponse> {
    const { targetCoreVersionX2, deploymentType } = data;

    const options: httpNetworking.GETRequestConfig = {};

    let response = await httpNetworking.simplePOSTRequest(
        UPGRADE_CORE_VERSION_URL,
        {
            targetCoreVersionX2,
            deploymentType
        },
        options,
        UPGRADE_CORE_VERSION_API_VERSION
    );
    return response.data as TUpgradeCoreVersionResponse;
}
